import React, { useContext, useState } from 'react';
import { ContextProps } from '../types/ContextProps';
import { LatestVoyageData } from '../types/ViewModel/LatestVoyageData';
import { TankersEvent } from '../types/ViewModel/TankersEvent';

export type EventDataForVoyages = {
    imoNumber: number;
    voyageNumbers: string[];
    lastFetchEpoch?: number;
};

type EventContextType = {
    fullEventArray: TankersEvent[] | null;
    deltaEventArray: TankersEvent[] | null;
    selectedEvent: TankersEvent | null;
    savedEvent: TankersEvent | null;
    eventDataForVoyageList: EventDataForVoyages | null;
    lastDeletEventDate: Date | null;
    lastEventChangeDate: Date | null;
    forceEventReloadDate: Date | null;
    setForceEventReloadDate: (date: Date | null) => void;
    lastNotValidatingEvent: TankersEvent | null;
    firstPortCallEventTime: Date | null;
    latestVoyageData: LatestVoyageData | null;
    cargoOperationsEvents: TankersEvent[] | null;
    setFullEventArray: (evList: TankersEvent[]) => void;
    setDeltaEventArray: (evList: TankersEvent[]) => void;
    setSelectedEvent: (event: TankersEvent | null) => void;
    setSavedEvent: (event: TankersEvent | null) => void;
    setEventDataForVoyageList: (voyList: EventDataForVoyages) => void;
    setLastDeleteEventDate: (boolean) => void;
    setLastEventChangeDate: (date: Date) => void;
    setLastNotValidatingEvent: (event: TankersEvent | null) => void;
    setFirstPortCallEventTime: (date: Date | null) => void;
    setLatestVoyageData: (latestVoyageData: LatestVoyageData | null) => void;
    setCargoOperationsEvents: (events: TankersEvent[] | null) => void;
};

export const EventContext = React.createContext<EventContextType>(undefined!);

export const EventProvider = ({ children }: ContextProps) => {
    const [fullEventArray, setFullEventArray] = useState<TankersEvent[] | null>(null);
    const [deltaEventArray, setDeltaEventArray] = useState<TankersEvent[] | null>(null);
    const [selectedEvent, setSelectedEvent] = useState<TankersEvent | null>(null);
    const [savedEvent, setSavedEvent] = useState<TankersEvent | null>(null);
    const [eventDataForVoyageList, setEventDataForVoyageList] = useState<EventDataForVoyages>(null);
    const [lastDeletEventDate, setLastDeleteEventDate] = useState<Date | null>(null);
    const [lastEventChangeDate, setLastEventChangeDate] = useState<Date | null>(null);
    const [forceEventReloadDate, setForceEventReloadDate] = useState<Date | null>(null);
    const [lastNotValidatingEvent, setLastNotValidatingEvent] = useState<TankersEvent | null>(null);
    const [firstPortCallEventTime, setFirstPortCallEventTime] = useState<Date | null>(null);
    const [latestVoyageData, setLatestVoyageData] = useState<LatestVoyageData | null>(null);
    const [cargoOperationsEvents, setCargoOperationsEvents] = useState<TankersEvent[] | null>(null);

    return (
        <EventContext.Provider
            value={{
                fullEventArray,
                setFullEventArray,
                deltaEventArray,
                setDeltaEventArray,
                selectedEvent,
                setSelectedEvent,
                eventDataForVoyageList,
                setEventDataForVoyageList,
                savedEvent,
                setSavedEvent,
                lastDeletEventDate,
                setLastDeleteEventDate,
                lastEventChangeDate,
                setLastEventChangeDate,
                forceEventReloadDate,
                setForceEventReloadDate,
                lastNotValidatingEvent,
                setLastNotValidatingEvent,
                firstPortCallEventTime,
                setFirstPortCallEventTime,
                latestVoyageData,
                setLatestVoyageData,
                cargoOperationsEvents,
                setCargoOperationsEvents,
            }}
        >
            {children}
        </EventContext.Provider>
    );
};

export const useEventStore = () => useContext(EventContext);
